import styled from "styled-components";

export const NotificationTextContainerContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.notification.contentBorderColor};
  border-radius: 4px;

  padding: 1rem;

  box-shadow: 0px 0px 48px 0px
    ${({ theme }) => `${theme.console.tableOptionsBackground}14`};

  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
